
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ isLoggedIn, isSignedUp, auth, onLogout, children }) => {
  // If not logged in, redirect to the login page
  if (!isLoggedIn) {
    // return <Navigate to="/login" />;    
    return <Navigate to="/" />;    
  }

  if(isLoggedIn)
  {
    // console.log("HELP");
    // console.log(JSON.stringify(auth));

    if(auth.user == undefined)
    {
      onLogout();
      return (<p>Please wait...</p>);
    }
    if(auth.user.accountReset == true)
    {
      let resetPath=`/reset/${auth.user.resetHash}`;
      return <Navigate to={resetPath}/>;    
    }
    
    if(auth.user.sysPage != true)
    {
        if(auth.user.inactive==true)
        {

          return <Navigate to="/email-verification" />;    
        }
        if(auth.user.subscribed == false /*&& auth.user.allowTrial==false */)
        {
          return <Navigate to="/subscription-setup" />;      

        }

        /*
        if(auth.user.allowTrial == true && auth.user.subscribed==false)
        {
            let now = Date.now();
        
            let diff = now - auth.user.timeFreeStart;
        
            let numFreeDays = auth.user.freeDays*24*60*60*1000;
        
            if(diff > numFreeDays)
            {
              return <Navigate to="/subscription-setup" />;      
            }            
        }
        */

        if(auth.user.subscribed==true)
        {
          // check Expiry
        }
        /*
        if(isSignedUp==1)
        {
          return <Navigate to="/email-verification" />;    
        }
        if(isSignedUp==2)
        {
          return <Navigate to="/subscription-setup" />;    
        }
        */
      }
    }

  // If logged in, render the children (protected content)
  return children;
};

export default ProtectedRoute;
